(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["case-pair-selector"] && !Shopify.designMode) return;
  try {
    class CasePairSelector extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(() => this.update());
      this.observer.observe(this.section, { childList: true, subtree: true });
      this.fillDefaultCases();
      this.update();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('click', this.onClick);
      this.querySelector('dialog').close();
      this.observer?.disconnect();
      if (this.variantPickerOrigin?.isConnected && this.variantPicker) {
        this.variantPickerOrigin.replaceWith(this.variantPicker);
      }
      this.section?.removeAttribute('data-case-pair-active');
    }

    variantFor(card) {
      return Array.from(card.querySelector('[data-variants]').options).find(option =>
        option.dataset.model === card.querySelector('[data-model]').value && option.dataset.finish === card.querySelector('input[data-finish]:checked').value
      );
    }

    setCase(slot, card, option) {
      const template = this.querySelector('template[data-design="' + card.dataset.designCard + '"]');
      if (!template || !option) return;
      const selected = slot.querySelector('[data-second-case], [data-third-case]');
      selected.replaceChildren(template.content.cloneNode(true));
      const options = Array.from(card.querySelector('[data-variants]').options).filter(item => Number(item.dataset.price) === Number(this.dataset.price));
      const model = selected.querySelector('[data-inline-model]');
      model.setAttribute('aria-label', model.dataset.modelLabel + ', ' + slot.querySelector(':scope > small').textContent);
      for (const value of new Set(options.map(item => item.dataset.model))) {
        const item = document.createElement('option');
        item.value = value;
        item.textContent = value;
        model.append(item);
      }
      const finishes = selected.querySelector('[data-inline-finishes]');
      finishes.setAttribute('aria-label', finishes.querySelector('legend').textContent + ', ' + slot.querySelector(':scope > small').textContent);
      for (const value of new Set(options.map(item => item.dataset.finish))) {
        const label = document.createElement('label');
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = `case-finish-${this.dataset.productId}-${slot.dataset.caseNumber}`;
        input.value = value;
        input.setAttribute('data-inline-finish', '');
        const text = document.createElement('span');
        text.textContent = value;
        label.append(input, text);
        finishes.append(label);
      }
      this.applyInlineVariant(slot, card, option);
      slot.querySelector(':scope > [data-open-picker]').hidden = true;
    }

    applyInlineVariant(slot, card, option) {
      if (!option || Number(option.dataset.price) !== Number(this.dataset.price)) return;
      slot.dataset.variant = option.value;
      slot.dataset.design = card.dataset.designCard;
      const selected = slot.querySelector('[data-second-case], [data-third-case]');
      selected.querySelector('[data-variant-summary]').textContent = option.textContent;
      selected.querySelector('[data-inline-model]').value = option.dataset.model;
      const options = Array.from(card.querySelector('[data-variants]').options).filter(item => Number(item.dataset.price) === Number(this.dataset.price));
      const finishes = selected.querySelector('[data-inline-finishes]');
      for (const choice of finishes.querySelectorAll('input[data-inline-finish]')) {
        choice.disabled = !options.some(item => item.dataset.model === option.dataset.model && item.dataset.finish === choice.value);
        choice.checked = choice.value === option.dataset.finish;
      }
      for (const change of selected.querySelectorAll('[data-change-design]')) {
        change.setAttribute('aria-label', change.dataset.changeLabel + ' ' + slot.querySelector(':scope > small').textContent + ': ' + selected.querySelector('strong').textContent + ', ' + option.textContent);
      }
      const image = selected.querySelector('img');
      image.loading = 'eager';
      if (option.dataset.image) {
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
      }
    }

    fillDefaultCases() {
      if (this.hasAttribute('data-builder')) return;
      const firstScript = this.section.querySelector('variant-picker script[type="application/json"]');
      const first = firstScript ? JSON.parse(firstScript.textContent) : null;
      const used = new Set([this.dataset.productId]);
      const slots = Array.from(this.querySelectorAll('[data-extra-case]'));
      for (const slot of slots) if (slot.dataset.design) used.add(slot.dataset.design);
      for (const slot of slots) {
        if (slot.dataset.variant) continue;
        const candidates = Array.from(this.querySelectorAll('[data-design-card]')).filter(card =>
          !used.has(card.dataset.designCard) && Array.from(card.querySelector('[data-variants]').options).some(option => Number(option.dataset.price) === Number(this.dataset.price))
        );
        if (!candidates.length) continue;
        const matching = candidates.filter(card => Array.from(card.querySelector('[data-variants]').options).some(option =>
          Number(option.dataset.price) === Number(this.dataset.price) && option.dataset.model === first?.option1 && option.dataset.finish === first?.option2
        ));
        const pool = matching.length ? matching : candidates;
        const card = pool[Math.floor(Math.random() * pool.length)];
        const options = Array.from(card.querySelector('[data-variants]').options).filter(option => Number(option.dataset.price) === Number(this.dataset.price));
        const option = options.find(option => option.dataset.model === first?.option1 && option.dataset.finish === first?.option2) || options[0];
        this.setCase(slot, card, option);
        used.add(card.dataset.designCard);
      }
    }

    onChange = (event) => {
      const card = event.target.closest('[data-design-card]');
      if (card) card.querySelector('[data-pick]').disabled = !this.variantFor(card);
      if (event.target.matches('[data-inline-model], [data-inline-finish]')) {
        const slot = event.target.closest('[data-extra-case]');
        const design = this.querySelector('[data-design-card="' + slot.dataset.design + '"]');
        const options = Array.from(design.querySelector('[data-variants]').options).filter(item => Number(item.dataset.price) === Number(this.dataset.price));
        const model = slot.querySelector('[data-inline-model]').value;
        const current = options.find(item => item.value === slot.dataset.variant);
        const finish = event.target.matches('[data-inline-finish]') ? event.target.value : current?.dataset.finish;
        const option = options.find(item => item.dataset.model === model && item.dataset.finish === finish) || options.find(item => item.dataset.model === model);
        this.applyInlineVariant(slot, design, option);
      }
      this.querySelector('[data-pair-error]').hidden = true;
      this.update();
    };

    onClick = (event) => {
      const button = event.target.closest('button');
      const dialog = this.querySelector('dialog');
      if (button?.hasAttribute('data-open-picker')) {
        this.activeCase = button.closest('[data-extra-case]')?.dataset.caseNumber || '2';
        const currentSlot = button.closest('[data-extra-case]');
        if (currentSlot?.dataset.design) {
          const card = this.querySelector('[data-design-card="' + currentSlot.dataset.design + '"]');
          const option = Array.from(card?.querySelector('[data-variants]')?.options || []).find(option => option.value === currentSlot.dataset.variant);
          if (option) {
            card.querySelector('[data-model]').value = option.dataset.model;
            for (const radio of card.querySelectorAll('[data-finish]')) radio.checked = radio.value === option.dataset.finish;
          }
        }
        if (this.hasAttribute('data-builder')) {
          this.activeSlot = button.dataset.slotNumber || button.closest('[data-slot]').dataset.slot;
          const otherSlot = this.querySelector('[data-slot="' + (this.activeSlot === '1' ? '2' : '1') + '"]');
          for (const card of this.querySelectorAll('[data-design-card]')) card.hidden = card.dataset.designCard === otherSlot.dataset.design;
        }
        dialog.showModal();
      }
      if (button?.hasAttribute('data-close-picker')) dialog.close();
      if (button?.dataset.pick) {
        const template = this.querySelector('template[data-design="' + button.dataset.pick + '"]');
        const option = this.variantFor(button.closest('[data-design-card]'));
        if (!template || !option) return;
        if (this.hasAttribute('data-builder')) {
          const slot = this.querySelector('[data-slot="' + this.activeSlot + '"]');
          const otherSlot = this.querySelector('[data-slot="' + (this.activeSlot === '1' ? '2' : '1') + '"]');
          if (button.dataset.pick === otherSlot.dataset.design || Number(option.dataset.price) !== Number(this.dataset.price)) return;
          slot.dataset.design = button.dataset.pick;
          slot.dataset.variant = option.value;
          slot.dataset.inCart = 'false';
          slot.replaceChildren(template.content.cloneNode(true));
          slot.querySelector('[data-variant-summary]').textContent = option.textContent;
          slot.querySelector('[data-change-design]').setAttribute('aria-label', 'Change ' + slot.querySelector('strong').textContent + ', ' + option.textContent);
          this.querySelector('[data-pair-error]').hidden = true;
          dialog.close();
          this.update();
          slot.querySelector('[data-change-design]').focus();
          return;
        }
        const slot = this.querySelector('[data-extra-case][data-case-number="' + this.activeCase + '"]');
        if (!slot || Number(option.dataset.price) !== Number(this.dataset.price)) return;
        this.setCase(slot, button.closest('[data-design-card]'), option);
        this.querySelector('[data-pair-error]').hidden = true;
        dialog.close();
        this.update();
        slot.querySelector('[data-change-design]').focus();
      }
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    };

    get pairSelected() {
      return this.hasAttribute('data-builder') || this.querySelector('input[value="pair"]').checked;
    }

    getItems(firstVariantId) {
      if (this.hasAttribute('data-builder')) {
        const slots = Array.from(this.querySelectorAll('[data-slot]'));
        const options = slots.map(slot => Array.from(this.querySelector('[data-design-card="' + slot.dataset.design + '"] [data-variants]')?.options || []).find(option => option.value === slot.dataset.variant));
        if (slots[0].dataset.design === slots[1].dataset.design || options.some(option => !option || Number(option.dataset.price) !== Number(this.dataset.price))) {
          const error = this.querySelector('[data-pair-error]');
          error.textContent = this.dataset.error;
          error.hidden = false;
          return false;
        }
        return options.filter(option => !this.cartVariantIds?.has(String(option.value))).map(option => ({ id: option.value, quantity: 1 }));
      }
      if (!this.pairSelected) return null;
      const slots = Array.from(this.querySelectorAll('[data-extra-case]'));
      const options = slots.map(slot => Array.from(this.querySelector('[data-design-card="' + slot.dataset.design + '"] [data-variants]')?.options || []).find(option => option.value === slot.dataset.variant));
      if (!firstVariantId || slots.length !== 2 || options.some(option => !option?.value || Number(option.dataset.price) !== Number(this.dataset.price))) {
        const error = this.querySelector('[data-pair-error]');
        error.hidden = false;
        error.textContent = this.dataset.error;
        const missing = slots.find((slot, index) => !options[index] || Number(options[index].dataset.price) !== Number(this.dataset.price));
        missing?.querySelector('[data-open-picker]')?.focus();
        return false;
      }
      const items = new Map();
      for (const id of [String(firstVariantId), ...options.map(option => option.value)]) {
        items.set(id, { id, quantity: (items.get(id)?.quantity || 0) + 1 });
      }
      return Array.from(items.values());
    }

    updateSticky(active) {
      const sticky = this.section.querySelector('sticky-add-to-cart[data-case-product]');
      if (!sticky) return;
      sticky.toggleAttribute('data-pair-selected', active);
      for (const selector of ['[data-sticky-pair-plus]', '[data-sticky-second-case]', '[data-sticky-third-plus]', '[data-sticky-third-case]', '[data-sticky-pair-price]']) {
        const element = sticky.querySelector(selector);
        if (element) element.hidden = !active;
      }
      const singlePrice = sticky.querySelector('[data-sticky-single-price]');
      if (singlePrice) singlePrice.hidden = active;
      const price = sticky.querySelector('[data-sticky-pair-price]');
      const offerPrice = this.querySelector('template[data-pair-total]');
      if (price && price.innerHTML !== offerPrice.innerHTML) price.innerHTML = offerPrice.innerHTML;
      for (const number of ['second', 'third']) {
        const slot = sticky.querySelector('[data-sticky-' + number + '-case]');
        const source = this.querySelector('[data-' + number + '-case] img');
        if (slot && source && slot.querySelector('img')?.getAttribute('src') !== source.getAttribute('src')) {
          slot.replaceChildren(source.cloneNode(true));
        }
      }
    }

    placeVariantPicker(active) {
      const picker = this.section.querySelector('variant-picker');
      const target = this.querySelector('[data-offer-variants="' + (active ? 'pair' : 'single') + '"]');
      if (!picker || picker.dataset.productId !== this.dataset.productId || !target) return;
      if (!this.variantPickerOrigin) {
        this.variantPickerOrigin = document.createComment('Phone-case variant picker origin');
        picker.before(this.variantPickerOrigin);
      }
      this.variantPicker = picker;
      for (const slot of this.querySelectorAll('[data-offer-variants]')) slot.hidden = slot !== target;
      const mount = target.querySelector('[data-native-picker-target]');
      if (mount && picker.parentElement !== mount) mount.append(picker);
    }

    update() {
      if (this.hasAttribute('data-builder')) {
        const slots = Array.from(this.querySelectorAll('[data-slot]'));
        const button = this.querySelector('button[name="add"]');
        const disabled = !slots.every(slot => slot.dataset.variant) || slots[0].dataset.design === slots[1].dataset.design || this.querySelector('product-form-component').dataset.pairSubmitting === 'true';
        if (button.disabled !== disabled) button.disabled = disabled;
        return;
      }
      const active = this.pairSelected;
      this.placeVariantPicker(active);
      this.section.toggleAttribute('data-case-pair-active', active);
      this.querySelector('[data-pair-options]').hidden = !active;
      const picker = this.section.querySelector('variant-picker');
      const variantData = picker?.querySelector('script[type="application/json"]');
      if (variantData) {
        const variant = JSON.parse(variantData.textContent);
        for (const summary of this.querySelectorAll('[data-first-variant-summary]')) {
          if (summary.textContent !== variant.title) summary.textContent = variant.title;
        }
        const source = variant.featured_image?.src;
        for (const image of this.querySelectorAll('[data-current-case-image] img')) {
          if (source && image.dataset.variantSource !== source) {
            image.removeAttribute('srcset');
            const thumbnail = new URL(source, window.location.origin);
            thumbnail.searchParams.set('width', '400');
            image.src = thumbnail.href;
            image.dataset.variantSource = source;
          }
        }
      }
      this.updateSticky(active);
      for (const form of this.section.querySelectorAll('product-form-component')) {
        if (form.dataset.productId !== this.dataset.productId) continue;
        for (const button of form.querySelectorAll('button[name="add"]')) {
          const text = Array.from(button.childNodes).find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
          if (!text || button.disabled) continue;
          if (!button.dataset.singleLabel) button.dataset.singleLabel = text.textContent.trim();
          const label = active ? this.dataset.addLabel : button.dataset.singleLabel;
          if (text.textContent.trim() !== label) text.textContent = label;
        }
      }
    }
  }
  if (!customElements.get('case-pair-selector')) customElements.define('case-pair-selector', CasePairSelector);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["phone-case-discovery"] && !Shopify.designMode) return;
  try {
    class PhoneCaseDiscovery extends HTMLElement {
    controller = new AbortController();
    disconnectedCallback() { this.controller.abort(); }
    connectedCallback() {
      this.closest('.shopify-section')?.addEventListener('shopify:product:select', (event) => {
        if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
        event.promise.then(({ detail }) => {
          const replacement = detail?.html?.querySelector('phone-case-discovery');
          if (replacement) this.replaceWith(replacement);
        }).catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[phone-case-discovery] Selection update failed:', error);
        });
      }, { signal: this.controller.signal });
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-direction]');
        if (!button) return;
        const track = this.querySelector('.phone-case-discovery__track');
        track.scrollBy({ left: Number(button.dataset.direction) * track.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
    }
  }
  if (!customElements.get('phone-case-discovery')) customElements.define('phone-case-discovery', PhoneCaseDiscovery);
  } catch(e) { console.error(e); }
})();

})();
